import { isTrueValue } from "@utils/utilsValidators";

export function buildPathPayload(
  inputForm: Record<string, any>,
): Record<string, any> {
  let objToSend: Record<string, any> = {
    title: inputForm.title || "",
    description: inputForm.description || "",
    detail_description: inputForm.detail_description || "",
    note: inputForm.note || "",
    complexity: inputForm.complexity || null,
    cover_id: inputForm.cover_id || undefined,
    specializations: inputForm.specializations || "NONE",
    propaedeutic_logics: inputForm.propaedeutic_logics || null,

    didactical_activity: inputForm.didactical_activity || [],
    lo: inputForm.lo || [],
    duration: inputForm.duration || null,
    certificate_ids: inputForm.certificate_ids || [],
    completable_flag: String(isTrueValue(inputForm.completable_flag) || false),
    stakeholders: inputForm.stakeholders ?? [],
    signature_certificate_ids: inputForm.signature_certificate_ids || [],
    completable: isTrueValue(inputForm.completable),
    expected_compl_time: +inputForm.expected_compl_time || undefined,
    publish_date: inputForm.publish_date || null,
    obsolescent_date: inputForm.obsolescent_date || null,
    expiration_date: inputForm.expiration_date || null,
    soft_expiring: !(isTrueValue(inputForm.soft_expiring) || false),
    highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
    highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
    didactical_material: inputForm.didactical_material || [],
    badge_id: inputForm.badge_id || null,
    score: +inputForm.score || 0,
    persona:
      inputForm?.persona?.map((el: any) => el.value?.toUpperCase()) || [],
    test_id: +inputForm.test_id || null,
    survey_id: Number(inputForm.survey_id) || undefined,
    test_logic: inputForm.test_logic || null,
    test_min_score: inputForm.test_min_score ?? undefined,
    max_attempt: +inputForm.max_attempt || null,
    fixed_expiration: isTrueValue(inputForm.fixed_expiration) || false,
    useful_links: inputForm.useful_links,
    knowledge_domain: inputForm.knowledge_domain || null,
    learning_purpose: inputForm.learning_purpose || null,
    digited_code: inputForm.digited_code || null,

    ecm_specialization: inputForm.specializations === "ECM",
    event_start_date: inputForm.event_start_date || null,
    event_end_date: inputForm.event_end_date || null,
    event_credits: Number(inputForm.event_credits) || null,
    training_goal: inputForm.training_goal || null,
    event_training_type: inputForm.event_training_type || null,
    special_cases: inputForm.special_cases || null,
    tutors: inputForm.tutors ?? [],
    teachers: inputForm.teachers ?? [],
    lecturers: inputForm.lecturers ?? [],
    moderators: inputForm.moderators ?? [],
    scientific_managers: inputForm.scientific_managers ?? [],

    lo_to_complete: inputForm.lo_to_complete,
    min_completition_perc: inputForm.min_completition_perc,
    completition_minutes: inputForm.completition_minutes,
    completition_minutes_perc: inputForm.completition_minutes_perc,
    credits: inputForm.credits,
    lo_tag: inputForm.lo_tag ?? [],
  };

  if (!isTrueValue(inputForm.expiration_date_flag)) {
    objToSend = {
      ...objToSend,
      expiration_date: 253402214400000,
      soft_expiring: true,
      fixed_expiration: true,
      expected_compl_time: 1,
    };
  }

  if (!objToSend.obsolescent_date) {
    objToSend.obsolescent_date = "9999-12-31";
  }

  if (objToSend.useful_links == null) {
    delete objToSend.useful_links;
  }
  if (objToSend.survey_id === undefined) {
    delete objToSend.survey_id;
  }
  if (objToSend.test_min_score === undefined) {
    delete objToSend.test_min_score;
  }
  if (objToSend.credits === undefined || objToSend.credits === "") {
    delete objToSend.credits;
  }
  (
    [
      "lo_to_complete",
      "min_completition_perc",
      "completition_minutes",
      "completition_minutes_perc",
    ] as const
  ).forEach((k) => {
    if (objToSend[k] === undefined) delete objToSend[k];
  });

  return objToSend;
}
